import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { reduxForm, startSubmit } from 'redux-form';
import HeaderButton from '../../components/header-button';
import postFormSettings from '../../services/post-form-settings';
import commentFormSettings from '../../services/comment-form-settings';
import messages, { REQUIRE_POST_FIELDS } from '../../components/message/messages';
import withEnvironment from '../../hoc/with-environment';

export class PublishButton extends Component {
  handleClick = () => {
    const { submit, invalid } = this.props;
    if (!invalid) {
      return submit();
    }

    const { showMessage, errors } = this.props;
    const emptyFields = [];
    _.forOwn(errors, (error, field) => {
      if (error === 'required') {
        emptyFields.push(field);
      }
    });

    if (emptyFields.length) {
      showMessage(messages[REQUIRE_POST_FIELDS].content(emptyFields), messages[REQUIRE_POST_FIELDS].type);
    }
  };

  render = () => {
    const { text, errors } = this.props;
    return (
      <HeaderButton
        text={text}
        onClick={this.handleClick}
        isMuted={errors.content === 'uploading'}
        data-role="publish"
      />
    );
  };
}

PublishButton.propTypes = {
  text: PropTypes.string,
  invalid: PropTypes.bool,
  submit: PropTypes.func.isRequired,
  showMessage: PropTypes.func.isRequired,
  errors: PropTypes.object,
  formName: PropTypes.string,
};

PublishButton.defaultProps = {
  text: 'publish-button.publish',
  formName: 'post',
};

const mapDispatchToProps = (dispatch, { formName }) =>
  bindActionCreators(
    {
      submit: () => startSubmit(formName),
    },
    dispatch
  );

export const PostPublishButton = _.flowRight(
  reduxForm(postFormSettings, undefined, mapDispatchToProps),
  withEnvironment({ showMessage: 'showMessage' })
)(PublishButton);

export const CommentPublishButton = _.flowRight(
  reduxForm(commentFormSettings, undefined, mapDispatchToProps),
  withEnvironment({ showMessage: 'showMessage' })
)(PublishButton);



// WEBPACK FOOTER //
// ./app/containers/publish-button/publish-button.js